<app-main-navigation></app-main-navigation>
<app-price-robot-submenu></app-price-robot-submenu>

<ng-container *ngIf="competitor != null && !loading; else spinner">
    <div class="container pb-1" [ngClass]="{faded:loading}">
        <p class="h1 mt-4 mb-4 d-flex justify-content-center">
            {{competitor.name}}
            <button class="btn btn-outline-primary ms-4 mt-2" (click)="openModal(content)">
                Edit competitor
            </button>
        </p>

<!--        <ng-container *ngIf="showFullUrl">
            <input class="btn btn-primary mt-4 mb-4" type="button" value="Skjul fuld link"
                   (click)="showFullUrl = false">
        </ng-container>
        <ng-container *ngIf="!showFullUrl">
            <input class="btn btn-primary mt-4 mb-4" type="button" value="Vis fuld link" (click)="showFullUrl = true">
        </ng-container>-->

        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a href="#" [routerLink]="[]" [queryParams]="{page:1,mode:'pending'}"
                   [queryParamsHandling]="'merge'"
                   class="nav-link"
                   [ngClass]="{'active': mode==='pending'}">Vis afventer</a>
            </li>
            <li class="nav-item">
                <a [routerLink]="[]" [queryParams]="{page:1,mode:'error'}"
                   [queryParamsHandling]="'merge'"
                   class="nav-link"
                   [ngClass]="{'active': mode==='error'}">Vis fejl</a>
            </li>
            <li class="nav-item">
                <a [routerLink]="[]" [queryParams]="{page:1,mode:'approved'}"
                   [queryParamsHandling]="'merge'"
                   class="nav-link"
                   [ngClass]="{'active': mode==='approved'}">Vis godkendte</a>
            </li>
        </ul>


        <ng-template #content let-modal>
            <div class="modal-header" [ngClass]="{faded:loading}">
                <h4 class="modal-title">Ændre konkurrent</h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" [ngClass]="{faded:loading}">
                <div class="mt-4">
                    <div class="form-group">
                        <label for="name">Navn</label>
                        <input type="text" class="form-control" id="name" [(ngModel)]="competitor.name" name="name">
                    </div>
                    <div class="form-group">
                        <label for="url">Base url</label>
                        <input type="text" class="form-control" id="url" [(ngModel)]="competitor.url" name="url">
                    </div>
                    <div class="form-group">
                        <label for="processClass">Process klasse</label>
                        <input type="text" class="form-control" id="processClass" [(ngModel)]="competitor.process_class"
                               name="processClass">
                    </div>
                    <div class="form-group">
                        <label for="preferenceClass">Preference klasse</label>
                        <input type="text" class="form-control" id="preferenceClass"
                               [(ngModel)]="competitor.preference_class" name="preferenceClass">
                    </div>
                    <input type="button" value="Gem konkurrent" (click)="saveCompetitor()" class="btn btn-primary"
                           id="edit">
                </div>
            </div>
        </ng-template>

        <div *ngIf="urls.length > 0">
            <p class="h2 mt-10">
                <ng-container *ngIf="mode==='pending'">Afventer</ng-container>
                <ng-container *ngIf="mode==='approved'">Godkendte</ng-container>
                <ng-container *ngIf="mode==='error'">Fejl</ng-container>
            </p>
            <table class="table table-striped align-middle mt-4">
                <tr>
                    <th>Navn</th>
                    <th>Varenummer</th>
                    <th>Konkurrent URL</th>
                    <th>Intern URL</th>
                    <th>Screenshot</th>
                    <th>Score</th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
                <tbody>
                <tr *ngFor="let url of urls">
                    <td>
                        <a *ngIf="url.product" [routerLink]="'/price-robot/product/' + url.product.id">
                            {{url.product.name}}
                        </a>
                    </td>
                    <td>
                        <p *ngIf="url.product">
                            {{url.product.getCustomFieldValue('ean')}}
                        </p>
                    </td>
                    <td>
                        <ng-container *ngIf="showFullUrl">
                            <p *ngIf="url.url !== null">
                                <a href="{{url.url}}" target="_blank">{{url.url}}</a>
                            </p>
                        </ng-container>
                        <ng-container *ngIf="!showFullUrl">
                            <p *ngIf="url.url !== null">
                                <a href="{{url.url}}" target="_blank">Konkurrent link</a>
                            </p>
                        </ng-container>
                    </td>
                    <td>
                        <p *ngIf="url.product">
                            <a href="{{url.product.getCustomFieldValue('original_url')}}"
                               target="_blank">10-4 link</a>
                        </p>
                    </td>
                    <td>
                        <img *ngIf="url.screenshot_url !== null" alt="screenshot" width="150" height="150"
                             src="{{url.screenshot_url}}" (click)="openLargeModal(imageContent)">
                    </td>
                    <ng-template #imageContent let-modal>
                        <div class="modal-header" [ngClass]="{faded:loading}">
                            <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" [ngClass]="{faded:loading}">
                            <img *ngIf="url.screenshot_url !== null" alt="screenshot" class="img-fluid"
                                 src="{{url.screenshot_url}}">
                        </div>
                    </ng-template>
                    <td>{{url.score}}</td>
                    <td style="display: flex;align-items: center;justify-content: space-between;gap: 0.25rem">
                        <button class="btn btn-outline-primary" (click)="enqueue(url)">
                            Crawl
                        </button>

                        <button class="btn btn-outline-primary" (click)="edit(url, true)" *ngIf="!url.is_approved">
                            Godkend
                        </button>

                        <button class="btn btn-outline-primary" (click)="openLargeModal(pendingContent)" *ngIf="!url.is_approved">
                            Check og Godkend
                        </button>


                        <ng-template #pendingContent let-modal>
                            <div class="modal-header" [ngClass]="{faded:loading}">
                                <h4 class="modal-title">Ændre URL</h4>
                                <button type="button" class="close" aria-label="Close"
                                        (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body" [ngClass]="{faded:loading}">
                                <div style="display: flex;align-items: stretch" >
                                    <iframe
                                            style="border: none; width: 50%;"
                                            [src]="url.product.getCustomFieldValue('original_url') | safeResourceUrlPipe"></iframe>
                                  <!--  <img *ngIf="url.original_screenshot_url !== null" alt="screenshot orig" width="50%"
                                         src="{{url.original_screenshot_url}}"> -->
                                    <a
                                            style="width: 50%"
                                            [href]="url.screenshot_url" target="_blank">
                                        <img *ngIf="url.screenshot_url !== null" alt="screenshot"
                                             class="img-fluid"
                                             src="{{url.screenshot_url}}">
                                    </a>
                                </div>
                                <div class="mt-4">
                                    <div class="form-group" *ngIf="url.product">
                                        <label for="pending_crawler_url">Vores Url</label>
                                        <div class="input-group">
                                            <input [disabled]="true" type="text" class="form-control"
                                                   [value]="url.product.getCustomFieldValue('original_url')">
                                            <div class="input-group-append">
                                                <div class="input-group-text" style="width: auto;">
                                                    <a [href]="url.product.getCustomFieldValue('original_url')"
                                                       target="_blank">
                                                        <i class="fas fa-external-link-alt"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label for="pending_crawler_url">Url</label>
                                        <div class="input-group">
                                            <input type="text" class="form-control" id="pending_crawler_url"
                                                   [(ngModel)]="url.url" name="url">
                                            <div class="input-group-append">
                                                <div class="input-group-text" style="width: auto;">
                                                    <a [href]="url.url" target="_blank">
                                                        <i class="fas fa-external-link-alt"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Varenummer</label>
                                        <input type="text" readonly class="form-control-plaintext" id="staticEmail"
                                               [value]="url.product.getCustomFieldValue('ean')">
                                    </div>
                                </div>
                                <button class="btn btn-danger" (click)="delete(url)">Slet URL</button>
                                <button class="btn btn-primary float-right" (click)="edit(url, true)">Godkend URL
                                </button>
                            </div>
                        </ng-template>
                    </td>
                </tr>
                </tbody>
            </table>

            <ngb-pagination
                    [(page)]="page"
                    [pageSize]="10"
                    [maxSize]="10"
                    [collectionSize]="meta.count">

                <ng-template ngbPaginationPages let-page let-pages="pages" let-disabled="disabled">
                    <li *ngFor="let pageNumber of pages" class="page-item" [class.active]="pageNumber === page"
                        [class.disabled]="pageNumber === -1 || disabled" [attr.aria-current]="(pageNumber === page ? 'page' : null)">
                        <a *ngIf="pageNumber === -1" class="page-link" tabindex="-1" aria-disabled="true">
                            ...
                        </a>
                        <a *ngIf="pageNumber !== -1" class="page-link"
                           [routerLink]="[]"
                           [queryParams]="{page:pageNumber}" [preserveFragment]="true" [queryParamsHandling]="'merge'"
                           [attr.tabindex]="disabled ? '-1' : null" [attr.aria-disabled]="disabled ? 'true' : null">
                            {{pageNumber}}
                        </a>
                    </li>
                </ng-template>



            </ngb-pagination>
        </div>
    </div>
</ng-container>


<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>
